/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_Insight_SubtitleInputs */

const en_us2_today_insight_subtitle = /** @type {(inputs: Today_Insight_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About your training`)
};

const pt_br2_today_insight_subtitle = /** @type {(inputs: Today_Insight_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre o seu treino`)
};

const es_419_today_insight_subtitle = /** @type {(inputs: Today_Insight_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre tu entrenamiento`)
};

const pt_pt2_today_insight_subtitle = /** @type {(inputs: Today_Insight_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre o teu treino`)
};

const fr_fr2_today_insight_subtitle = /** @type {(inputs: Today_Insight_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À propos de ton entraînement`)
};

const de_de2_today_insight_subtitle = /** @type {(inputs: Today_Insight_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu deinem Training`)
};

const it_it2_today_insight_subtitle = /** @type {(inputs: Today_Insight_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sul tuo allenamento`)
};

/**
* | output |
* | --- |
* | "About your training" |
*
* @param {Today_Insight_SubtitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_insight_subtitle = /** @type {((inputs?: Today_Insight_SubtitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Insight_SubtitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_insight_subtitle(inputs)
	if (locale === "es-419") return es_419_today_insight_subtitle(inputs)
	if (locale === "pt-PT") return pt_pt2_today_insight_subtitle(inputs)
	if (locale === "fr-FR") return fr_fr2_today_insight_subtitle(inputs)
	if (locale === "de-DE") return de_de2_today_insight_subtitle(inputs)
	if (locale === "it-IT") return it_it2_today_insight_subtitle(inputs)
	return en_us2_today_insight_subtitle(inputs)
});
export { today_insight_subtitle as "today.insight_subtitle" }